/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Pattern_Deleted_UnnamedInputs */



/**
* | output |
* | --- |
* | "A custom pattern was deleted and no longer monitors requests." |
*
* @param {Audit_Details_Pattern_Deleted_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_deleted_unnamed = /** @type {((inputs?: Audit_Details_Pattern_Deleted_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Deleted_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein eigenes Muster wurde gelöscht und prüft keine Anfragen mehr.")
	return /** @type {LocalizedString} */ ("A custom pattern was deleted and no longer monitors requests.")
});